/**
 * ชื่อแดงพเนจร (systems/redRoamers.ts): now and then, offline, a simulated player with a red name roams the wilds
 * of a big zone, so a คู่แค้น (systems/social.ts) can happen without other people online. Rare, telegraphed (a warning
 * first, the blade only after `warnSeconds`), avoidable (slower than the player, gives up past `giveUp` m, never in a
 * safe zone) and never on the first hour's path (`minQuest`). Data only.
 */
import type { ZoneId } from './zones';

export const RED_ROAMERS = {
  /** Zones they roam (their wilds: the layout's regions, outside the safe outline). */
  zones: ['yanyu2' as ZoneId] as readonly ZoneId[],
  /** Not before this many story quests are done (the first hour's path stays clear). */
  minQuest: 3,
  /** Seconds between the rolls, and the chance a roll brings one (only while the player is in the wilds). */
  rollEvery: 30,
  chance: 0.25,
  /** Seconds after one leaves before the next roll. */
  cooldown: 300,
  /** Where one turns up: this many metres from the player. */
  spawnMin: 26,
  spawnMax: 34,
  /** The warning: given within `warnAt` m; the attack comes `warnSeconds` later (rivals strike within 9 m). */
  warnAt: 18,
  warnSeconds: 3,
  /** Past this many metres the roamer lets the player go (PK off again until the next warning). */
  giveUp: 30,
  /** Seconds a roamer roams before leaving (once the player is `leaveAt` m away). */
  life: 240,
  leaveAt: 40,
  /** Body against the player's own: health, strikes, and pace (slower: running away works). */
  hp: 1,
  atk: 0.85,
  speed: 0.85,
  /** PK points of a roamer: a red name (over `PK.red`, under purple). */
  pkPoints: 3000,
} as const;
